/**
 * SG PreSet — officer / controller / shareholder 조회 시 IS_DEL=0 만 사용.
 * 챗플로우 officer-list · 폼 자동바인딩 공통 진입점.
 */
import { docGenApi } from '@/features/AI-documents/api/docGenApi';
import { filterActiveEntityRows } from './sgEntityActiveRowFilter';

function activeRows(rows: unknown): any[] {
  if (!Array.isArray(rows)) return [];
  return filterActiveEntityRows(rows as Record<string, unknown>[]);
}

export async function getActiveDirectors(entityCd: string) {
  const res: any = await docGenApi.getDirectors(entityCd);
  return {
    ...res,
    data: {
      directors: activeRows(res?.data?.directors),
    },
  };
}

export async function getActiveSecretaries(entityCd: string) {
  const res: any = await docGenApi.getSecretaries(entityCd);
  return {
    ...res,
    data: {
      secretaries: activeRows(res?.data?.secretaries),
    },
  };
}

export async function getActiveAuditors(entityCd: string) {
  const res: any = await docGenApi.getAuditors(entityCd);
  return {
    ...res,
    data: {
      auditors: activeRows(res?.data?.auditors),
    },
  };
}

export async function getActiveMembers(entityCd: string) {
  const res: any = await docGenApi.getMembers(entityCd);
  return {
    ...res,
    data: {
      members: activeRows(res?.data?.members),
    },
  };
}

export async function getActiveControllers(entityCd: string) {
  const res: any = await docGenApi.getControllers(entityCd);
  const raw = Array.isArray(res?.data?.controllers)
    ? res.data.controllers
    : Array.isArray(res?.data)
      ? res.data
      : [];
  return {
    ...res,
    data: {
      controllers: activeRows(raw),
    },
  };
}

export async function getActiveEntityOfficersAll(entityCd: string) {
  const res: any = await docGenApi.getEntityOfficersAll(entityCd);
  return {
    ...res,
    data: {
      officers: activeRows(res?.data?.officers),
    },
  };
}

export async function getActiveCeos(entityCd: string) {
  const res: any = await docGenApi.getCeos(entityCd);
  return {
    ...res,
    data: {
      ceos: activeRows(res?.data?.ceos),
    },
  };
}

export async function getActiveBeneficialOwners(entityCd: string) {
  const res: any = await docGenApi.getBeneficialOwners(entityCd);
  const raw = res?.data?.beneficialOwners || res?.data?.controllers || [];
  // Legal Owner(IsBeneficialOwner=0) 제외 — 챗봇/CDD BO 목록 공통
  const onlyBo = (Array.isArray(raw) ? raw : []).filter((c: any) => {
    const flag = c?.isBeneficialOwner ?? c?.IsBeneficialOwner;
    if (flag === undefined || flag === null || String(flag).trim() === '') return true;
    return !(flag === 0 || flag === '0' || flag === false);
  });
  const filtered = activeRows(onlyBo);
  // 같은 contact 에 중복 BO 레코드(빈 것 + criteria 있는 것)가 있으면 criteria/지분 있는 레코드 우선.
  const score = (b: any) => (String(b?.criteriaText || '').trim() ? 2 : 0) + (String(b?.ownershipPercent || '').trim() ? 1 : 0);
  const byContact = new Map<string, any>();
  let anon = 0;
  for (const b of filtered) {
    const key = String(b?.contactCd || b?.CONTACT_CD || b?.id || '').trim() || `__anon_${anon++}`;
    const prev = byContact.get(key);
    if (!prev || score(b) > score(prev)) byContact.set(key, b);
  }
  const deduped = [...byContact.values()];
  return {
    ...res,
    data: {
      beneficialOwners: deduped,
      controllers: deduped,
    },
  };
}
